import React from "react";
import PropTypes from "prop-types";

const ServerError = (props) => {
    const alertClassName = props.isVisible ? "alert alert-danger" : "hidden";

    const divProps = {
        role: "alert",
        className: alertClassName
    };
    if (props.id){
        divProps.id = props.id;
    }

    return (<div {...divProps}>
        <span className="alertSummaryText">{props.errorSummary}</span>
        <span className="errorMessage">{props.serverError}</span>
    </div>);
};

ServerError.propTypes = {
    id: PropTypes.string,
    isVisible : PropTypes.bool,
    errorSummary: PropTypes.string,
    serverError: PropTypes.string
};

export default ServerError;
